import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';

export const SMART_PRICING_TAGS = Object.freeze({
  SMART_PRICING_RULES: 'smart_pricing_rules',
});

export const smartPricingApiSlice = createApi({
  reducerPath: 'smartPricingApiSlice',
  baseQuery,
  tagTypes: Object.values(SMART_PRICING_TAGS),
  endpoints: (builder) => ({
    getSmartPricingRule: builder.query({
      query: ({ apiManager, id }) => apiManager.show(id),
    }),
    uploadSmartPricingRuleImage: builder.mutation({
      query: ({ apiManager, id, data }) => apiManager.uploadImage(id, data),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return [SMART_PRICING_TAGS.SMART_PRICING_RULES];
      },
    }),
    deleteSmartPricingRuleImage: builder.mutation({
      query: ({ apiManager, id, data }) => apiManager.deleteImage(id, data),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return [SMART_PRICING_TAGS.SMART_PRICING_RULES];
      },
    }),
    generateSmartPricingRuleImage: builder.mutation({
      query: ({ apiManager, id }) => apiManager.generateImage(id),
    }),
  }),
});

export const {
  useGetSmartPricingRuleQuery,
  useUploadSmartPricingRuleImageMutation,
  useDeleteSmartPricingRuleImageMutation,
  useGenerateSmartPricingRuleImageMutation,
} = smartPricingApiSlice;
